import { AxiosError } from "axios";
import { PaginateResult } from "core/resources/types/shared";
import http from "infra/http";
import { useQuery } from "react-query";
import { VeiculoItem, ListarVeiculosQuery } from "../typings";

export function useListarVeiculos(query: ListarVeiculosQuery) {
  return useQuery<PaginateResult<VeiculoItem>, AxiosError>(
    `/v1/veiculo-${query.page}-${query.limit}-${query.search}-${query.unidadeId}`,
    async () => {
      const {data} = await http.get<PaginateResult<VeiculoItem>>('/v1/veiculo', {params: query})

      return data;
    }
  );
}
